"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OidcUrlHelper = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _OidcTokenStorage = require("./storage/OidcTokenStorage");
var OidcUrlHelper = function OidcUrlHelper() {
    var _this = this;
    _class_call_check(this, OidcUrlHelper);
    (0, _defineProperty2.default)(this, "storage", new _OidcTokenStorage.OidcTokenStorage());
    (0, _defineProperty2.default)(this, "storeAuthCodeFromParams", function(params) {
        _this.validateParams(params);
        var authCode = params.get(OidcUrlHelper.AUTH_CODE);
        if (authCode === null) {
            throw new Error("Auth - missing authorization code");
        }
        _this.storage.authorizationCode.set(authCode);
        _this.storage.state.remove();
        _this.storage.nonce.remove();
    });
    (0, _defineProperty2.default)(this, "handleRedirectAfterLogin", function() {
        var redirectUrl = _this.storage.redirectUrl.get();
        _this.storage.redirectUrl.remove();
        if (typeof redirectUrl === 'string') {
            window.location.href = redirectUrl;
        }
    });
    (0, _defineProperty2.default)(this, "validateParams", function(params) {
        var errorParam = params.get('error');
        var stateParam = params.get('state');
        if (errorParam !== null) {
            throw new Error("Auth - ".concat(errorParam));
        }
        if (stateParam !== _this.storage.state.get()) {
            throw new Error("Auth - incorrect state");
        }
    });
};
exports.OidcUrlHelper = OidcUrlHelper;
(0, _defineProperty2.default)(OidcUrlHelper, "AUTH_CODE", 'code'); //# sourceMappingURL=OidcUrlHelper.js.map
